/* ==========================================================================
   stools2 — scroll reveal (Flux/Dawn-style slide-up + cascade)
   Elements get .reveal (hidden) and .reveal-in (shown) via IntersectionObserver.
   Grids stagger their items with --reveal-i. Auto-tags a curated selector set
   so sections don't each need markup changes.
   ========================================================================== */

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  /* container → item: items reveal with a staggered delay */
  const groups = [
    ['.hero__track', '.hero__card'],
    ['.tabbed-products__track', '.tabbed-products__item'],
    ['.collection-list__track', '.collection-card'],
    ['.list-collections__grid', '.collection-card'],
    ['.fblog__grid', '.fpost'],
    ['.benefits', '.benefits__item'],
    ['.stats__grid', '.stats__item'],
    ['.testimonials__track', '.tcard'],
    ['.promo__track', '.promo-card'],
    ['.exdeals__track', '.exdeals__promo, .exdeals__item']
  ];

  /* standalone elements that reveal as a single block */
  const singles = [
    '.hero__content',
    '.pdp__gallery', '.pdp__info', '.pdp__buy',
    '.pdp-related__head',
    '.rich-text__inner',
    '.iwt__media-col', '.iwt__content',
    '.tabbed-products__heading', '.tabbed-products__controls',
    '.its',
    '.collection-list__head',
    '.promo__head',
    '.deal__image-col', '.deal__product-col',
    '.fblog__head',
    '.testimonials__head',
    '.exdeals__head',
    '.cta-banner__content'
  ];

  const observed = new Set();
  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('reveal-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function tag(el, i) {
    if (!el || observed.has(el)) return;
    observed.add(el);
    el.classList.add('reveal');
    if (i) el.style.setProperty('--reveal-i', i);
    io.observe(el);
  }

  groups.forEach(function (pair) {
    document.querySelectorAll(pair[0]).forEach(function (container) {
      container.querySelectorAll(pair[1]).forEach(function (el, i) { tag(el, i); });
    });
  });

  singles.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) { tag(el, 0); });
  });
})();

/* Idle preload: once the page settles, upgrade lazy images inside tabbed /
   promo tracks to eager so switching tabs/sliders shows photos instantly. */
(function () {
  function preload() {
    var imgs = document.querySelectorAll('.tabbed-products img[loading="lazy"], .promo__track img[loading="lazy"], .exdeals__track img[loading="lazy"]');
    imgs.forEach(function (img) { img.loading = 'eager'; });
  }
  function schedule() {
    if ('requestIdleCallback' in window) requestIdleCallback(preload, { timeout: 2500 });
    else setTimeout(preload, 1800);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule);
})();
